import { getReporter } from './reporter'

/**
 * 监控主线程长任务
 *
 * 使用 PerformanceObserver 监听 longtask 类型，
 * 只上报 duration > 100ms 的任务以控制数据量
 */
export function setupLongTasks(): void {
  if (typeof window === 'undefined' || typeof PerformanceObserver === 'undefined') return

  try {
    const observer = new PerformanceObserver(list => {
      const reporter = getReporter()
      if (!reporter) return

      for (const entry of list.getEntries()) {
        if (entry.duration <= 100) continue

        reporter.addLongTask({
          duration: entry.duration,
          startTime: entry.startTime,
          pagePath: location.pathname,
          timestamp: Date.now(),
        })
      }
    })

    observer.observe({ type: 'longtask', buffered: true })
  } catch {
    // 浏览器不支持 longtask 类型，静默跳过
  }
}
